module.exports = __webpack_public_path__ + "static/media/end_session.85982f62.png";